import { appEntryData } from '@/mocks/homeData';

export default function AppEntrySection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-4">
              {appEntryData.badge}
            </span>
            <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">{appEntryData.title}</h2>
            <p className="text-sm md:text-base text-foreground-600 mb-2 font-medium">{appEntryData.subtitle}</p>
            <p className="text-sm text-foreground-500 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">{appEntryData.description}</p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button className="w-full sm:w-auto px-7 py-2.5 bg-foreground-900 hover:bg-foreground-800 text-background-50 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-apple-line mr-2"></i>{appEntryData.iosLabel}
              </button>
              <button className="w-full sm:w-auto px-7 py-2.5 bg-accent-500 hover:bg-accent-600 text-white rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-android-line mr-2"></i>{appEntryData.androidLabel}
              </button>
            </div>
          </div>
          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-56 h-80 rounded-3xl bg-foreground-900 p-3 shadow-lg">
              <div className="w-full h-full rounded-2xl bg-background-100 flex flex-col items-center justify-center gap-3 p-4">
                <span className="w-10 h-10 rounded-xl bg-primary-500 flex items-center justify-center">
                  <i className="ri-fire-line text-white text-lg"></i>
                </span>
                <span className="text-xs font-bold text-foreground-800 font-heading">91黑料网</span>
                <span className="text-[10px] text-foreground-500">v3.8.2</span>
                <div className="w-full h-1 bg-background-200 rounded-full mt-2"></div>
                <div className="flex gap-1.5">
                  <span className="w-12 h-1 bg-primary-400 rounded-full"></span>
                  <span className="w-8 h-1 bg-background-200 rounded-full"></span>
                  <span className="w-16 h-1 bg-background-200 rounded-full"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}